import { useParams } from 'react-router-dom';

// Import actions
import { deleteVideoSession } from 'store/actions';

// Import hooks
import { useAppDispatch } from 'store/hooks';

// Import helpers
import { PLAYER_SELECTORS } from 'helpers/variables';
import { fetchMovieResources } from 'components/views/vod/views/Player/helpers';

const useNextMaterial = () => {
	const dispatch = useAppDispatch();
	const { type } = useParams();

	const handleFetchNextMaterial = async (uuid) => {
		// Delete video live session
		// Fetch movie resources
		await dispatch(deleteVideoSession({ type: PLAYER_SELECTORS.VOD })).then(() => {
			dispatch(fetchMovieResources({ uuid, type }));
		});
	};

	return { fetchNextMaterial: handleFetchNextMaterial };
};

export default useNextMaterial;
